import { EvmNFTChain } from '@repo/types-client';

/**
 * Returns the chain ID based on the provided EVM NFT chain and environment.
 * @function returnChain
 * @param {EvmNFTChain} chain - The EVM NFT chain.
 * @returns {number | null} The chain ID or null if the chain is not recognized.
 */
export const returnChain = (chain: EvmNFTChain): number | null => {
  const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production';

  switch (chain) {
    case 'ethereum':
      return isProduction ? 1 : 11155111;
    case 'base':
      return isProduction ? 8453 : 84532;
    default:
      return null;
  }
};
